module.exports = __webpack_public_path__ + "img/aboutUSHomeEn.ac21496c.png";